import React, { useEffect } from 'react';
import { Col, Row, Button, Label, Input } from "reactstrap";
import ReactMarkdown from "react-markdown";
import { FaPen, FaTrash } from "react-icons/fa6";
import { ITaskAction } from "../../../../interfaces/ITask";
import { objectIdToDate } from "../../../../Utils/taskUtils";
import { censorEmailsInDescription } from "../../../../Functions/Functions";
import Badge from "../../../Badge/Badge";

interface TaskHistoryProps {
  activities: ITaskAction[];
  userRole: string;
  onEditComment: (commentId: string, commentText: string) => void;
  onDeleteComment: (commentId: string) => void;
  onNewComment: () => void;
  activitiesFilter: string;
  setActivitiesFilter: (value: string) => void;
}

const TaskHistory: React.FC<TaskHistoryProps> = ({
  activities,
  userRole,
  onEditComment,
  onDeleteComment,
  onNewComment,
  activitiesFilter,
  setActivitiesFilter,
}) => {

  const [filteredActivities, setFilteredActivities] = React.useState<ITaskAction[]>(activities);

  React.useEffect(() => {
    if (activitiesFilter === "-1") {
      setFilteredActivities(activities);
    } else if (activitiesFilter === "0") {
      setFilteredActivities(
        activities.filter(
          (c) =>
            c.actionType === "Comment" ||
            c.actionType === "CommentUploadHomolog"
        )
      );
    } else if (activitiesFilter === "1") {
      setFilteredActivities(
        activities.filter(
          (c) => c.actionType === "JoinTask" || c.actionType === "LeaveTask"
        )
      );
    } else if (activitiesFilter === "2") {
      setFilteredActivities(activities.filter((c) => c.actionType === "MoveTask"));
    }
  }, [activities, activitiesFilter]);

  React.useEffect(() => {
    console.log(activities)
  }, [activities]);

  const getActionIcon = (actionType: string) => {
    switch (actionType) {
      case "Comment":
      case "CommentUploadHomolog":
        return "💬";
      case "JoinTask":
        return "👋";
      case "LeaveTask":
        return "🚪";
      case "MoveTask":
        return "🔄";
      default:
        return "📝";
    }
  };

  const getActionColor = (actionType: string) => {
    switch (actionType) {
      case "Comment":
      case "CommentUploadHomolog":
        return "#3b82f6";
      case "JoinTask":
        return "#10b981";
      case "LeaveTask":
        return "#ef4444";
      case "MoveTask":
        return "#f59e0b";
      default:
        return "#6b7280";
    }
  };

  return (
    <div className="history-section">
      <div className="history-header">
        <h3 className="history-title">
          🕒 Histórico de Atividades
        </h3>
        
        <div className="history-actions">
          <div className="history-filter-section">
            <Label className="history-filter-label">Filtrar por:</Label>
            <Input
              className="history-filter-select"
              type="select"
              value={activitiesFilter}
              onChange={(e) => setActivitiesFilter(e.target.value)}
            >
              <option value="0">Comentários</option>
              <option value="1">Movimentação de membros</option>
              <option value="2">Movimentação da tarefa</option>
              <option value="-1">Todos</option>
            </Input>
          </div>
          
          <Button
            className="history-new-comment-btn"
            onClick={() => onNewComment()}
          >
            💬 Novo Comentário
          </Button>
        </div>
      </div>

      <div className="history-timeline">
        {filteredActivities != null && filteredActivities.length > 0 ? (
          filteredActivities.map((comment, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-marker" style={{ backgroundColor: getActionColor(comment.actionType) }}>
                <span className="timeline-icon">{getActionIcon(comment.actionType)}</span>
              </div>
              
              <div className="timeline-content">
                <div className="timeline-header">
                  <div className="timeline-meta">
                    <span className="timeline-date">{objectIdToDate(comment.id)}</span>
                    <span className="timeline-separator">•</span>
                    <span className="timeline-creator">
                      {comment.creator != null ? comment.creator : "Usuário não identificado"}
                    </span>
                  </div>
                  
                  {comment.canEdit && (
                    <div className="timeline-actions">
                      <button
                        className="timeline-action-btn edit-btn"
                        onClick={() => {
                          onEditComment(comment.description, comment.id);
                        }}
                        title="Editar comentário"
                      >
                        <FaPen />
                      </button>
                      <button
                        className="timeline-action-btn delete-btn"
                        onClick={() => {
                          onDeleteComment(comment.id);
                        }}
                        title="Excluir comentário"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  )}
                </div>

                <div className="timeline-body">
                  <ReactMarkdown className="markdown timeline-markdown">
                    {userRole === "Viewer"
                      ? (comment.descriptionWithLinks
                        ? censorEmailsInDescription(comment.descriptionWithLinks)
                        : censorEmailsInDescription(comment.description))
                      : (comment.descriptionWithLinks
                        ? comment.descriptionWithLinks
                        : comment.description)}
                  </ReactMarkdown>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="history-empty">
            <div className="history-empty-icon">📝</div>
            <p>Nenhuma atividade encontrada para o filtro selecionado.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskHistory; 